
import { NavItemType } from 'types';
import generatedMenus from './generated-menus';

// ==============================|| MENU ITEMS ||============================== //

const menuItems: { items: NavItemType[] } = {
    items: [...generatedMenus]
};

export default menuItems;
